import plupload from 'plupload';
import {FileData, FileDataCollection} from './FileData';

export interface FileHandler {
    preInitSetup(plupload: any): void;
    setStore(store: any): void;
    setFileDataCollection(list: FileDataCollection): void;
    handleError(up: plupload.Uploader, error: plupload_error): void;
    handleFilesAdded(up: plupload.Uploader, file: plupload.File): void;
    handleBeforeChunkUpload(up: plupload.Uploader, file: plupload.File, info: any): void;
    handleChunkUploaded(up: plupload.Uploader, file: plupload.File, info: any): void;
    handleBeforeUpload(up: plupload.Uploader, file: plupload.File): void;
    handleUploadProgess(up: plupload.Uploader, file: plupload.File): void;
    handleFileUploaded(up: plupload.Uploader, file: plupload.File): void;
    isFileOfType(file: plupload.File, data: FileData): boolean;
    handlePaused(up: plupload.Uploader, currentFile: plupload.File): void;
    handleResume(up: plupload.Uploader, currentFile: plupload.File): void;
}

export interface FileHandlerOptions {
    allowedExtensions?: string[];
}

export abstract class DefaultFileHandler {
    protected fileData: FileDataCollection = {};
    protected store: any;
    protected options: FileHandlerOptions = {};

    constructor(options: FileHandlerOptions = {}) {
        this.options = options;
    }

    preInitSetup(plupload: any): void {
        plupload.addFileFilter('file_check', (enabled: boolean, file: plupload.File, cb: {(ok: boolean): void}) => {
            const ok = this.isValidExtension(file.name);
            if (!ok) {
                const fData = this.fileData[file.id];
                this.store.dispatch('files/setError', {reference: fData.file_id, message: 'Invalid extension.'});
            }
            cb(ok);
        });
    }

    setStore(store: any): void {
        this.store = store;
    }

    setFileDataCollection(list: FileDataCollection): void {
        this.fileData = list;
    }

    isValidExtension(fileName: string): boolean {
        if (!this.options.allowedExtensions || Object.values(this.options.allowedExtensions).length === 0) {
            return true;
        }

        const matches = fileName.match(/\.([0-9a-z]+)$/i);
        if (matches && matches.length > 0) {
            return this.options.allowedExtensions.indexOf(matches[1].toLowerCase()) > -1;
        }

        return false;
    }

    handleFileUploaded(up: plupload.Uploader, file: plupload.File): void {

    }
}

export class InvalidFileException {
    file: plupload.File;

    constructor(file: plupload.File) {
        this.file = file;
    }

    getFile(): plupload.File {
        return this.file;
    }

    toString(): string {
        return 'Invalid file';
    }
}
